var gs_diamond_filters = {
    init: function () {
        this.filters_tab_change();
        this.dummy_filter_button();
    },
    filters_tab_change: function () {
    },
    dummy_filter_button: function () {
        $('.filter-button-wrapper a').click(function () {
            $('#vdb_gs_filter_btn').trigger('click');
        });
    }
}

$(document).ready(function () {
    gs_diamond_filters.init();
});